var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bill-card',{attrs:{"header":_vm.header,"rightBtns":_vm.rightBtns}},[_c('bar-chart',{staticClass:"w-100",staticStyle:{"height":"200px"},attrs:{"columns":_vm.columns,"rows":_vm.rows,"label-map":_vm.labelMap,"setting-options":_vm.settingOptions}}),_vm._t("header-right",null,{"slot":"header-right"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }